import { ViewIds } from '@ardoq/api-types';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { getRightMenuConfig } from 'viewSettings/getRightMenuConfig';
import { replaceLegendButton, SettingsBar } from '@ardoq/settings-bar';
import { viewSettingsConsts } from '@ardoq/view-settings';
import { RelationshipsNode, RelationshipsViewSettings } from './types';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';
import { type TraversalViewModel, type HasViewpointMode } from '@ardoq/graph';
import { dispatchAction } from '@ardoq/rxbeach';
import { toggleLegend } from 'presentation/viewPane/actions';
import { viewLegendCommands } from '@ardoq/view-legend';
import { pngExporter } from 'tabview/pngExporter';
import { getExportLabels } from 'views/getExportLabels';
import { type I18nLocale } from '@ardoq/i18n';
import { toWorkspaceModeRelationshipsViewModifiers } from './workspaceMode/settingsControls';

const VIEW_ID = ViewIds.RELATIONSHIPS_3;

type RelationshipsViewSettingsBarProperties = TraversalViewModel &
  HasViewpointMode & {
    viewSettings: RelationshipsViewSettings;
    quickPerspectiveReferenceTypeFilters: Set<string> | null;
    getExportContainer: () => HTMLElement | null;
    createExportCanvas: () => Promise<HTMLCanvasElement | null>;
    addToPresentation: VoidFunction;
    collapsedGroupIds?: string[];
    rootNode: RelationshipsNode | null;
    activeGroups: string[];
    isEmptyView: boolean;
    viewInstanceId: string;
    i18nLocale: I18nLocale;
  };
const RelationshipsViewSettingsBar = (
  props: RelationshipsViewSettingsBarProperties
) => {
  const {
    viewSettings,
    getExportContainer,
    createExportCanvas,
    addToPresentation,
    isEmptyView,
    isViewpointMode,
    i18nLocale,
  } = props;

  const modifiers = toWorkspaceModeRelationshipsViewModifiers({
    dependencies: props,
    i18nLocale,
  });

  return (
    <SettingsBar
      viewId={VIEW_ID}
      leftMenu={modifiers}
      rightMenu={replaceLegendButton(
        viewSettings[viewSettingsConsts.IS_LEGEND_ACTIVE],
        getRightMenuConfig({
          isViewpointMode: false,
          viewId: VIEW_ID,
          viewstate: viewSettings,
          exports: {
            exportToPng: pngExporter({
              getExportContainer,
              getExportCanvas: createExportCanvas,
              viewId: ViewIds.RELATIONSHIPS_3,
              isViewpointMode,
              labels: getExportLabels(i18nLocale),
            }),
            addToPresentation,
            isDisabled: isEmptyView,
          },
          knowledgeBaseLink: KnowledgeBaseLink.RELATIONSHIPS,
          onViewSettingsUpdate,
          legendOnClick: () => {
            const newLegendActive = !viewSettings.isLegendActive;
            viewLegendCommands.updateViewLegendSettings({
              viewId: VIEW_ID,
              isActive: newLegendActive,
            });
            dispatchAction(
              toggleLegend({
                viewId: VIEW_ID,
                legendActive: newLegendActive,
              }),
              VIEW_ID
            );
          },
          i18nLocale,
        })
      )}
      i18nLocale={i18nLocale}
    />
  );
};

export { RelationshipsViewSettingsBar };
